var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as baobab from '@data/baobab/baobab';
import { useEffect, useState } from 'react';
import { cellsApi, evaluatorApi } from '@data/rest/api';
export default function useDataEditorData(dataEditorCols, dataEditorRows, wId) {
    var _this = this;
    var _a = __read(useState([]), 2), rowStrings = _a[0], setRowDataTags = _a[1];
    var _b = __read(useState([]), 2), colStrings = _b[0], setColDataTags = _b[1];
    var _c = __read(useState(null), 2), data = _c[0], setData = _c[1];
    useEffect(function () {
        setRowDataTags(dataEditorRows.map(function (row) { return getDataString(__spreadArray(__spreadArray([], __read(row.tagIds), false), [row.targetVersionTagId], false)); }));
    }, [dataEditorRows]);
    useEffect(function () {
        setColDataTags(dataEditorCols.map(function (col) { return getDataString(col.tagIds); }));
    }, [dataEditorCols]);
    var update = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, cellsApi.updateBatch(changes)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3:
                    if (!(rowStrings.length > 0 || colStrings.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetch(rowStrings, colStrings)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetch = function (rs, cs) { return __awaiter(_this, void 0, void 0, function () {
        var data_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    baobab.root.select('state', 'widgetsLoading', wId).set(true);
                    return [4 /*yield*/, evaluatorApi.evaluate({
                            rows: rs,
                            cols: cs,
                        })];
                case 1:
                    data_1 = _a.sent();
                    setData(data_1);
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 3:
                    baobab.root.select('state', 'widgetsLoading', wId).set(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (rowStrings.length > 0 && colStrings.length > 0) {
            fetch(rowStrings, colStrings).catch(function (e) { });
        }
    }, [rowStrings, colStrings]);
    return [data, update];
}
function getDataString(arr) {
    arr.sort(function (a, b) {
        var aa = Array.isArray(a) ? a[0] : a;
        var bb = Array.isArray(b) ? b[0] : b;
        return aa - bb;
    });
    var tags = arr.map(function (item) {
        if (Array.isArray(item)) {
            return item.join('|');
        }
        else {
            return "".concat(item);
        }
    });
    return "tags(".concat(tags.join(','), ")");
}
